const url = (query, keepQuery) => {
  const url = new URL(window.location);

  Object.keys(query)
    .forEach(key => {
      if(query[key] === undefined || query[key] === '') {
        url.searchParams.delete(key)
      } else {
        url.searchParams.set(key, query[key]);
      }
    });


  return url || ''
};

/**
 * 設定瀏覽器 History
 * @param data
 * @param title
 * @param query
 * @param keepQuery
 */
export default function setWindowHistory({
  data = {},
  title = '',
  query = {},
  keepQuery = true
} = {}) {
  // 這邊可以修改網址的參數 如果用$route.query是拿不到被動態改變的值 可以改成用getUrlParameter取query
  window.history.pushState(data, title, url(query, keepQuery));
}

/**
 * 取代瀏覽器 History
 * @param data
 * @param title
 * @param query
 * @param keepQuery
 */
export function replaceWindowHistory({
  data = {},
  title = '',
  query = {},
  keepQuery = true
} = {}) {
  window.history.replaceState(data, title, url(query, keepQuery));
}

/**
 * 取得網址參數
 * @param name
 * @returns {string|string}
 */
export function getUrlParameter(name) {
  // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  // 改成 searchParams.get
  name = name.replace(/[\[]/, '\\[')
    .replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
